import Loadable from 'app/components/Loadable'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const Home = Loadable(lazy(() => import('../pages/homePage/index')))

const homeRoutes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
]

export default homeRoutes
